import React, { useEffect, useState } from "react";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getTree } from '@craftercms/content';
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import EpisodeRedirect from "./components/EpisodeRedirect/EpisodeRedirect";
import HomePage from './containers/HomePage/HomePage';
import ArticlePage from './containers/ArticlePage/ArticlePage';
import SchedulePage from './containers/SchedulePage/SchedulePage';
import StaticPage from './containers/StaticPage/StaticPage';
import PagePortal from "./containers/PagePortal/PagePortal";
import ProgramPage from "./containers/ProgramPage/ProgramPage";
import VideoPage from "./containers/VideoPage/VideoPage";
import InYourArea from "./components/InYourArea/InYourArea";
import SearchPage from "./containers/SearchPage/SearchPage";
import LandingPage from "./containers/LandingPage/LandingPage";
import ShowsPage from "./containers/ShowsPage/ShowsPage";
import {crafterConf, httpGet} from "@craftercms/classes";
import {composeUrl} from "@craftercms/utils";
import NotFoundPage from "./containers/FourOhFour/NotFoundPage";

const en = {};
const fr = {};

const searchPages = {};

const Router = (props) => {

	const [pages, setPages] = useState([]);
	const [redirects, setRedirects] = useState(null);
	const HOME_PAGE_URL = "/site/website/";

	const getPath = (str) => {
		let url = str.replace('/site/website', '').replace('/index.xml', '');
		return url === "" ? "/" : url;
	}

	const processTree = (items, routeList) => {
		for (let index in items) {
			const {name, url, descriptorDom, children} = items[index];
			const path = getPath(url);

			if (
				(name === 'index.xml' && descriptorDom.page.page_url_fr) ||
				(name === 'index.xml' && descriptorDom.page['content-type'] == '/page/entry')
			) {
				const pathFR = `/${getPath(descriptorDom.page.page_url_fr || "")}`;
				const contentType = descriptorDom.page['content-type'];
				// Define route in English
				routeList.push({'content-type': contentType, 'url':path, 'path':url, 'lan':'en'});
				// Define route in French
				routeList.push({'content-type': contentType, 'url':pathFR, 'path':url, 'lan':'fr'});
				// Populating EN & FR Objects for URL Maping
				en[path] = pathFR;
				fr[pathFR] = path;

				if(contentType === "/page/search") {
					searchPages["en"] = path
					searchPages["fr"] = pathFR
				}
			}
			if (children) {
				processTree(children, routeList);
			}
		}
	}

	// get the URL as entered in the Browser
	const href = window.location.href;
	const regex = /(https?:\/\/)?([\w-\:\.]*)?\/(\bfr\b|\ben\b)\/(programs)\/([\w-]*)\/(episodes)\/(\d{8})\/?/;
	let groupToMatch = regex.exec(href);
	let episodeID = "";
	let lang = "";
	if(groupToMatch !== null) {
		episodeID = groupToMatch[7];
		lang = groupToMatch[3];
	}
	
	useEffect(() => {
		getTree(HOME_PAGE_URL, -1).subscribe((data) => {
			let routeList = [];
			processTree(data.children, routeList);

			props.setUrlMap({en, fr});
			props.setSearchPages(searchPages);
			setPages(routeList);
		});
	},[]);

	useEffect(() => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_REDIRECTS_FULL);
		if (!redirects) {
			httpGet(serviceUrl, {crafterSite: craftConf.site}).subscribe((data) => {
				if (data) {
					setRedirects(data)
				}
			});
		}
	}, []);

	const renderComponent = (page) => {
		switch(page['content-type']) {
			case '/page/article':
				return <ArticlePage url={page.path} lan={page.lan}/>;
			case '/page/portal':
				return <PagePortal url={page.path} lan={page.lan}/>;
			case '/page/search':
				return <SearchPage url={page.path} lan={page.lan}/>;
			case '/page/schedule':
				return <SchedulePage url={page.path} lan={page.lan}/>;
			case '/page/static':
				return <StaticPage url={page.path} lan={page.lan}/>;
			case '/page/program':
				return <ProgramPage url={page.path} lan={page.lan}/>;
			case '/page/video-page':
				return <VideoPage url={page.path} lan={page.lan}/>;
			case '/page/in-your-area':
				return <InYourArea url={page.path} type={page['content-type']} contentType={process.env.REACT_APP_IN_YOUR_AREA_CONTENT_TYPE}/>;
			case '/page/landing':
				return <LandingPage url={page.path} lan={page.lan}/>;
			case '/page/shows':
				return <ShowsPage url={page.path} lan={page.lan}/>;
			default:
				return <HomePage/>;
		}
	}

	return (
		<Switch>
			{pages.map((page, index) =>
				<Route key={index} exact path={page.url}>
					{() => renderComponent(page)}
				</Route>
			)}
			{redirects && redirects.map((redirect, index) =>
				<Route key={index} exact path={redirect.oldUrl}>
					<Redirect to={redirect.newUrl} />
				</Route>
			)}
			{groupToMatch &&
			<Route exact path={'/' + lang + '/**/' + episodeID}>
				<EpisodeRedirect lang={lang} episode={episodeID} />
			</Route>
			}
			{<Route>
				<NotFoundPage pages={pages} redirects={redirects} episode={episodeID} />
			</Route>}
		</Switch>
	)

}

const mapDispatchToProps = (dispatch) => ({
	setUrlMap: (map) => dispatch({ type: 'SET_URL_MAP', map}),
	setSearchPages: (pages) => dispatch({ type: 'SET_SEARCH_PAGES', pages: searchPages })
});

export default compose(withRouter,connect(null, mapDispatchToProps))(Router);